module.exports = __webpack_public_path__ + "img/footer-img.b6c68114.png";